import { createAction } from '@ngrx/store';

export const CLEAR_STATE_ACTION = (place: string) => createAction(`[${place}][Application] Clear State`);
